import { i18n } from '@/i18n'
import Cookie from 'js-cookie'

export function useT() {
  const t = (...args) => i18n.global.t(...args)
  const locale = i18n.global.locale

  // optional: lazy-load messages if locale not already loaded
  async function setLocale(newLocale) {
    if (!i18n.global.availableLocales.includes(newLocale)) {
      try {
        const messages = await import(`@/i18n/locales/${newLocale}.js`)
        i18n.global.setLocaleMessage(newLocale, messages.default)
      } catch (e) {
        console.error(`Locale file not found: ${newLocale}`, e)
        return
      }
    }
    locale.value = newLocale
    Cookie.set('locale', newLocale)
  }

  return { t, locale, setLocale }
}
